module.exports = __webpack_public_path__ + "static/img/img_codebanner.c7a3b529.png";